<div class="rangeslider">
    <input class="min" name="range_1" type="range" [min]="min" [max]="max" [(ngModel)]="minValue" (change)="rangeInputChangeEventHandler($event)"/>
    <input class="max second-range" name="range_1" type="range" [min]="min" [max]="max" [(ngModel)]="maxValue" (change)="rangeInputChangeEventHandler($event)"/>

    <span *ngIf="isPrice && maxValue < max" class="value-text">{{formatPrice(minValue)}} - {{formatPrice(maxValue)}}</span>
    <span *ngIf="isPrice && maxValue == max" class="value-text">{{formatPrice(minValue)}}</span>

    <span *ngIf="!isPrice" class="value-text">{{minValue}} - {{maxValue}}</span>
</div>
